import React, { useState, useEffect } from "react";
import axios from "axios";
import API_BASE from "../utils/api";

const rateColor = (rate) => (rate >= 75 ? "bg-green-500" : rate >= 50 ? "bg-yellow-500" : "bg-red-500");

// Pass percentage grouped by academic year — shared between the admin and
// principal dashboards.
const PassRateByYearWidget = () => {
  const [report, setReport] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API_BASE}/reports/pass-rate-by-year`)
      .then((res) => setReport(res.data))
      .catch(() => setReport(null))
      .finally(() => setLoading(false));
  }, []);

  const data = report?.data || [];

  return (
    <div className="bg-white rounded-lg shadow p-6">
      <div className="flex items-center justify-between flex-wrap gap-3 mb-4">
        <h3 className="text-lg font-semibold text-gray-800">🎓 Pass Percentage by Academic Year</h3>
        {report && (
          <span className="text-sm text-gray-500">
            Overall: <span className="font-semibold text-gray-800">{report.summary.overallPassRate}%</span>
          </span>
        )}
      </div>

      {loading ? (
        <p className="text-sm text-gray-400 text-center py-8">Loading…</p>
      ) : data.length === 0 ? (
        <p className="text-sm text-gray-400 text-center py-8">No approved exam results yet.</p>
      ) : (
        <div className="space-y-3">
          {data.map((d) => (
            <div key={d.academicYear}>
              <div className="flex justify-between text-sm mb-1">
                <span className="font-medium text-gray-700">{d.academicYear}</span>
                <span className="text-gray-500">{d.passCount}/{d.totalResults} passed &middot; {d.passRate}%</span>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-3">
                <div className={`h-3 rounded-full ${rateColor(d.passRate)}`} style={{ width: `${d.passRate}%` }} />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default PassRateByYearWidget;
